import {SET_ZOOM_ANIM, ZoomAnimAction, ZoomDataAnim, RESET_ZOOM_ANIM} from '../../Actions/Animator/zoom.anim.action';
import { RESET_ALL } from '../../Actions/globals.actions';

const defaultZoomData: ZoomDataAnim = {
    value: 100
}

const zoomAnim = (state: ZoomDataAnim = defaultZoomData, action: ZoomAnimAction ) => {
    switch (action.type) {
        case SET_ZOOM_ANIM: {
            return action.payload;
        } 
        case RESET_ZOOM_ANIM: {
            return defaultZoomData;
        }
        case RESET_ALL: {
            return defaultZoomData;
        }
        default: 
            return state;
    }
}

export default zoomAnim;